import type { AbilityDataDef } from './generated/abilities.gen';

const EXPLICIT_MELEE_TAGS = new Set(['melee', 'strike', 'slash']);
const EXPLICIT_PROJECTILE_TAGS = new Set(['ranged', 'projectile']);
const PROJECTILE_SCHOOLS = new Set(['fire', 'frost', 'arcane', 'shadow', 'nature', 'chaos']);

/**
 * Shared client/server delivery classification for TOML-backed abilities.
 *
 * The client uses this decision to build a live projectile whose collision
 * sends the authoritative damage request. The server must use the same
 * decision to avoid also applying damage at cast completion (NET-01).
 * Explicit melee tags win over visual metadata and school fallbacks.
 */
export function usesProjectileDelivery(data: AbilityDataDef | null | undefined): boolean {
  if (!data) return false;

  const tags = data.tags ?? [];
  if (tags.some((tag) => EXPLICIT_MELEE_TAGS.has(tag))) return false;
  if (tags.some((tag) => EXPLICIT_PROJECTILE_TAGS.has(tag))) return true;

  if (data.vfx?.projectileShape || data.vfx?.projectileSpeed) return true;
  if (data.school === 'physical' || data.school === 'holy') return false;
  return PROJECTILE_SCHOOLS.has(data.school ?? '');
}
